function IntroSlideGraphicAI({}) {
  return (
    <svg width='100%' viewBox='0 0 390 308' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M275 180L112 180' stroke='#48484A' strokeWidth='5' strokeLinecap='round' />
      <path
        d='M173.424 149.454L264.476 149.454C271.305 149.454 279.5 149.454 279.5 138.527'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path
        d='M212.576 149.454L121.524 149.454C114.695 149.454 106.5 149.454 106.5 138.527'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path
        d='M173.424 209.546L264.476 209.546C271.305 209.546 279.5 209.546 279.5 220.473'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path
        d='M212.576 209.546L121.524 209.546C114.695 209.546 106.5 209.546 106.5 220.473'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path d='M193 97L193 261' stroke='#48484A' strokeWidth='5' strokeLinecap='round' />
      <path
        d='M162.953 199.076L162.953 108.024C162.953 101.195 162.953 93 152.026 93'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path
        d='M162.953 159.924L162.953 250.976C162.953 257.805 162.953 266 152.026 266'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path
        d='M223.047 199.076L223.047 108.024C223.047 101.195 223.047 93 233.974 93'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <path
        d='M223.047 159.924L223.047 250.976C223.047 257.805 223.047 266 233.974 266'
        stroke='#48484A'
        strokeWidth='5'
        strokeLinecap='round'
      />
      <rect x='137' y='121' width='113' height='111' rx='12' fill='#1A1A1A' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M179.076 182.447C172.399 182.447 167 187.952 167 194.73C167 201.508 172.405 207 179.076 207C185.747 207 191.139 201.508 191.139 194.73C191.139 187.952 185.734 182.447 179.076 182.447ZM187.892 151.25H171.165C169.127 151.25 167.449 152.948 167.449 155.038V172.035C167.449 174.119 169.127 175.823 171.165 175.823H187.892C189.943 175.823 191.608 174.119 191.608 172.035V155.038C191.608 152.955 189.943 151.25 187.892 151.25Z'
        fill='#D1D1D6'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M219.482 181.123H202.754C200.45 181.123 198.583 183.026 198.583 185.373V202.37C198.583 204.711 200.45 206.608 202.754 206.608H219.482C221.786 206.608 223.653 204.711 223.653 202.37V185.373C223.653 183.033 221.786 181.123 219.482 181.123ZM220.514 202.364C220.514 202.955 220.045 203.425 219.482 203.425H202.754C202.172 203.425 201.71 202.949 201.71 202.364V185.367C201.71 184.775 202.178 184.306 202.754 184.306H219.482C220.051 184.306 220.514 184.782 220.514 185.367V202.364Z'
        fill='#D1D1D6'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M211.468 151C204.544 151 198.937 156.711 198.937 163.746C198.937 170.781 204.544 176.479 211.468 176.479C218.392 176.479 224 170.781 224 163.746C224 156.711 218.38 151 211.468 151ZM211.468 173.302C206.278 173.302 202.063 169.013 202.063 163.746C202.063 158.479 206.285 154.19 211.468 154.19C216.652 154.19 220.861 158.466 220.861 163.746C220.861 169.026 216.652 173.302 211.468 173.302Z'
        fill='#D1D1D6'
      />
      <path
        d='M126.459 83C126.459 77.4772 121.982 73 116.459 73H77C71.4771 73 67 77.4772 67 83V95.6182C67 101.141 71.4771 105.618 77 105.618H116.322C117.408 105.618 118.465 105.972 119.332 106.626L126.459 112V83Z'
        fill='#2D7455'
      />
      <circle
        cx='3.19672'
        cy='3.19672'
        r='3.19672'
        transform='matrix(-1 0 0 1 113.032 87.0664)'
        fill='#D1D1D6'
      />
      <circle
        cx='3.19672'
        cy='3.19672'
        r='3.19672'
        transform='matrix(-1 0 0 1 99.6064 87.0664)'
        fill='#D1D1D6'
      />
      <circle
        cx='3.19672'
        cy='3.19672'
        r='3.19672'
        transform='matrix(-1 0 0 1 86.1807 87.0664)'
        fill='#D1D1D6'
      />
      <path
        d='M253 284C253 290.627 258.373 296 265 296H312.656C319.283 296 324.656 290.627 324.656 284V268.691C324.656 262.063 319.283 256.691 312.656 256.691H267.217C264.609 256.691 262.073 255.842 259.992 254.272L253 249V284Z'
        fill='#354B9B'
      />
      <circle
        cx='3.85246'
        cy='3.85246'
        r='3.85246'
        transform='matrix(1 0 0 -1 269.181 279.049)'
        fill='#D1D1D6'
      />
      <circle
        cx='3.85246'
        cy='3.85246'
        r='3.85246'
        transform='matrix(1 0 0 -1 285.36 279.049)'
        fill='#D1D1D6'
      />
      <circle
        cx='3.85246'
        cy='3.85246'
        r='3.85246'
        transform='matrix(1 0 0 -1 301.541 279.049)'
        fill='#D1D1D6'
      />
    </svg>
  );
}

export default IntroSlideGraphicAI;
